import { createAPI } from '@common'

export default {
  // getAdDetail: (config) => createAPI('customEncryptApiName-1/0w20be0efubjm', 'get', config),
  // 获取详情
  getAdDetail: (config) => createAPI('customEncryptApiName-1/0nfejby.dpmvno0be0efubjm', 'get', config),
  // postAd: (config) => createAPI('customEncryptApiName-1/0w20be', 'post', config),
  // 新建
  postAd: (config) => createAPI('customEncryptApiName-1/0nfejby.dpmvno0be', 'post', config),
  // 修改
  // putAd: (config) => createAPI('customEncryptApiName-1/0w20be', 'put', config),
  putAd: (config) => createAPI('customEncryptApiName-1/0nfejby.dpmvno0be', 'put', config),
  // 获取配置
  // getAdConfig: (config) => createAPI('customEncryptApiName-1/0w20be0dpogjh', 'GET', config),
  getAdConfig: (config) => createAPI('customEncryptApiName-1/0nfejby.dpmvno0be0dpogjh', 'GET', config),
  // 启动页设置
  // postAdConfig: (config) => createAPI('customEncryptApiName-1/0w20be0dpogjh', 'POST', config)
  postAdConfig: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0be0dpogjh', 'POST', config),
  adPreview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0be0beQsfwjfx', 'get', config),
  // 导出广告统计
  exportAdStat: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0be0fyqpsu', 'post', config),
  // 获取广告统计详情
  getAdStatDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0be0tubu', 'post', config),
  // 导出广告统计详情
  exportAdStatDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0be0tubu0fyqpsu', 'post', config)
}
